<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="chatSetting"
        :items="chatSetting"
        :fields="fields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedChatSetting"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedChatSetting: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Tech support chat?"', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_CHAT_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_CHAT_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedChatSetting = JSON.parse(JSON.stringify(item))
      this.$bvModal.show('modalEditChatSettings')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedChatSetting = {
        group_id: 0,
        id: 0,
        is_enabled: 0
      }
      this.$bvModal.show('modalEditChatSettings')
    }
  },
  computed: {
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    chatSetting () {
      return this.$store.getters['Settings/CHAT_SETTINGS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_CHAT_SETTINGS')
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/chat/main.vue